import { toast } from '@backyard-ui/core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { HttpClient } from '@/application/interfaces/http-client';
import { Services } from '@/infra/services';
import {
  type Data,
  type Response,
} from '@/infra/services/checkout/cart/post-cart-address';

type ErrorType = HttpClient.Response<{ errors: { message: string }[] }> | Error;

export interface UsePostCartAddressProps
  extends UseMutationOptions<Response, ErrorType, Data> {}

const DEFAULT_ERROR_MESSAGE =
  'Erro ao salvar endereço no carrinho. Tente novamente.';

export const usePostCartAddress = (
  options?: Readonly<UsePostCartAddressProps>
) => {
  return useMutation({
    mutationFn: (data: Data) => Services.Checkout.Cart.postCartAddress(data),
    ...options,
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);
    },
    onError: (error, variable, context) => {
      const isKnownError =
        error instanceof HttpClient.Response && error.body?.errors?.length;

      const errorMessage =
        isKnownError && error.body.errors?.[0].message
          ? error.body.errors[0].message
          : DEFAULT_ERROR_MESSAGE;

      toast({
        description: errorMessage,
        appearance: 'critical',
      });

      options?.onError?.(error, variable, context);
    },
  });
};
